import MANewsPage from './MANewsPage'

export { MANewsPage }

export default MANewsPage
